import axios from 'axios'
import store from '@/store'

const baseURL = process.env.VUE_APP_API_BASE_URL || 'https://test.rufftuffdata.net:8085/'
const _axios = axios.create({
  baseURL
})

_axios.interceptors.request.use(config => {
  store.commit('setLoading', true)
  return config
})

_axios.interceptors.response.use(response => {
  store.commit('setLoading', false)
  return response
})

export default _axios
